import { Button, Grid } from '@farewill/ui'
import apiRequest from 'lib/axios/api-request'
import { FuneralPlanPaymentType } from 'lib/models/lead'

export const FakePaymentButton = ({
  leadId,
  funeralPlanId,
  paymentType,
  amountInPence,
  onPaymentCreated,
}: (
  | { leadId: number; funeralPlanId?: never }
  | { funeralPlanId: string; leadId?: never }
) & {
  paymentType: FuneralPlanPaymentType
  amountInPence: number
  /** Called once the invoice has been created */
  onPaymentCreated?: () => void
}): React.ReactElement => (
  <Grid.Item>
    <Button.Bordered
      type="button"
      onClick={async () => {
        await apiRequest({
          url: `/api/invoices`,
          method: 'POST',
          data: {
            data: {
              type: 'invoices',
              attributes: {
                ...(leadId !== undefined ? { leadId } : { funeralPlanId }),
                paidTo: 'farewill',
                paidOn: new Date(),
                issuedDate: new Date(),
                reference: 'fake-payment',
                externalReferenceId: 'fake-payment',
                lineItems: [
                  {
                    description:
                      paymentType === 'instalments'
                        ? 'instalment'
                        : 'payment in full',
                    price: amountInPence,
                    quantity: 1,
                    taxRate: 0,
                  },
                ],
              },
            },
          },
        })
        onPaymentCreated?.()
      }}
    >
      Fake payment (mirror only)
    </Button.Bordered>
  </Grid.Item>
)
